import { Badge, Stack } from "@shopify/polaris";
import { get } from "lodash";
import React from "react";

import { checkPlatform } from "../../../helper";
import { CustomLinkPolaris } from "../../shared/CustomLinkPolaris";
import { useTiktokInfoCtx } from "../context/LabelLinkContext";

export default function LabelLinkBadge({ node }) {
    const id = get(node, "id");
    // const platform = get(node, "store.platform");
    // const { isTiktok } = checkPlatform(platform);

    const { fileUrls } = useTiktokInfoCtx();
    // if (!isTiktok) return null;


    let labelLink = get(node, "labelLink");
    const isOrderLabel = get(node, "isOrderLabel");

    if (!!labelLink && (fileUrls || {})[id]) {
        // order has label link => get link from MB
        labelLink = (fileUrls || {})[id];
    }

    if (!labelLink && !isOrderLabel) return null;

    const shippingLabel = get(node, "shippingLabel");
    let tracking = "";
    if (shippingLabel && shippingLabel?.trackingCode) {
        tracking = (
            <p>
                <b>Tracking: </b>
                <span>
                    {shippingLabel.trackingCode}{" "}
                    {shippingLabel.carrier ? `( ${shippingLabel.carrier} )` : ""}
                </span>
            </p>
        );
    }

    const orderLabelMarkup = <Badge status="success" children="Tiktok Label" />;

    return (
        <Stack vertical>
            {labelLink ? (
                <CustomLinkPolaris href={labelLink}>
                    {orderLabelMarkup}
                </CustomLinkPolaris>
            ) : isOrderLabel ? (
                <div>{orderLabelMarkup}</div>
            ) : null}

            {tracking}
        </Stack>
    );
}
